<div class="filter-settings">
  <button 
    nbButton 
    ghost 
    size="small"
    class="settings-trigger"
    (click)="openModal()">
    <nb-icon icon="filter"></nb-icon>
  </button>
</div>

<ng-template #filterSettingsModal let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>
      <h2>{{ 'shared.filter_settings.title' | translate }}</h2>
    </nb-card-header>
    
    <nb-card-body>
            <div class="modal-content">
        <div 
          *ngFor="let filter of filters" 
          class="filter-item"
          [class.disabled]="filter.required || filter.active">
          <nb-checkbox 
            [checked]="filter.visible"
            [disabled]="filter.required || filter.active"
            (checkedChange)="toggleFilter(filter)">
            {{ filter.label }}
            <span *ngIf="filter.required" class="required-indicator">*</span>
            <span *ngIf="filter.active" class="active-indicator">●</span>
          </nb-checkbox>
        </div>
      </div>
    </nb-card-body>
    
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" size="small" (click)="showAllFilters()">
          {{ 'shared.filter_settings.show_all' | translate }}
        </button>
        <button nbButton status="basic" size="small" (click)="hideAllFilters()">
          {{ 'shared.filter_settings.hide_all' | translate }}
        </button>
        <button nbButton status="primary" size="small" (click)="ref.close()">
          {{ 'shared.filter_settings.close' | translate }}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
